import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import api from '../api';

export default function Header() {
  const { user, isAdmin, logout } = useAuth();
  const { totalItems } = useCart();
  const [search, setSearch] = useState('');
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();

  useEffect(() => { api.get('/categories').then(r => setCategories(r.data)).catch(() => {}); }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (search.trim()) navigate(`/shop?search=${encodeURIComponent(search.trim())}`);
  };

  return (
    <header className="header">
      <div className="header-main">
        <Link to="/" className="logo">
          <img src="/logo-header.png" alt="StyleMe" style={{ height: 52, width: 'auto' }} />
        </Link>
        <form className="search-bar" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Search products, brands, categories..."
            value={search}
            onChange={e => setSearch(e.target.value)}
          />
          <button type="submit">🔍</button>
        </form>
        <nav className="header-nav">
          {user ? (
            <>
              <span style={{ color: '#ccc', fontSize: 13 }}>Hello, {user.name}</span>
              {isAdmin && <Link to="/admin">Admin</Link>}
              <Link to="/orders">My Orders</Link>
              <Link to="/wishlist">&#9825; Wishlist</Link>
              <Link to="/membership" style={{ color: '#4f46e5', fontWeight: 700 }}>💎 VIP</Link>
              <button onClick={() => { logout(); navigate('/'); }}>Sign Out</button>
            </>
          ) : (
            <>
              <Link to="/login">Sign In</Link>
              <Link to="/register">Register</Link>
              <Link to="/membership" style={{ color: '#4f46e5', fontWeight: 700 }}>💎 VIP</Link>
            </>
          )}
          <Link to="/cart">🛒 Cart<span className="cart-count">{totalItems}</span></Link>
        </nav>
      </div>
      <div className="header-sub">
        <div className="header-sub-inner">
          <Link to="/shop">All Products</Link>
          {categories.filter(c => {
            if (c.slug === 'uncategorized' || c.product_count === 0) return false;
            if (['store','swimwear','kitchen'].includes(c.slug)) return user?.role === 'admin';
            return true;
          }).map(c => (
            <Link key={c.id} to={`/shop?category=${c.slug}`}>{c.name}</Link>
          ))}
        </div>
      </div>
    </header>
  );
}
